import React, { useState } from "react";
import "components/Layout/style.css";
import Grid from "@mui/material/Grid";
import { useStore } from "_Store";
import LabelImgIcon from "assets/img/edit-pencil.svg";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import { useFormik } from "formik";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import {  Store } from "../../../../components/Ui";

const CahierLabel = (props) => {
  
  const { state } = useStore();
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const {
    state: {
      activeCampaign,
    }
  } = React.useContext(Store);
  const formik = useFormik({
    initialValues: {
      wording: null,
    },
    onSubmit: (val) => {
      val.campaignId=activeCampaign && activeCampaign.id ? activeCampaign.id : null;
      props.onSubmit(val,saveAndContinue);
    },
  });
  return (
    <div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          containImg={LabelImgIcon}
          content={"Journal de caisse"}
          title={"Libellé"}
          buttonLabel={"Continuer"}
          task={"Pour chaque écriture que vous saisissez, vous devez indiquer un libellé qui permette de savoir à quoi correspond l'écriture."}
          handleSubmit={(save)=>{
              formik.handleSubmit();            
              setSaveAndContinue(save);
          }}
          buttonDisabled={formik.values.wording===null || formik.values.wording.length <= 0}
        >
          <div className="mt-14 text-center mb-14">
          <Box component="form" noValidate autoComplete="off">
                            <TextField
                            style={{ minWidth:"50%" }}
                              name="wording"
                              label="Libellé de l'opération"
                              onChange={formik.handleChange}
                              value={
                                formik.values?.["wording"]
                              }
                              error={Boolean(
                                formik.errors?.["wording"]
                              )}
                              helperText={
                                formik.errors?.["wording"]
                              }
                            />
            </Box>
          </div>
        </WelcomeLayout>
      </Grid>
    </div>
  );
};

export default CahierLabel;
